module.exports = __webpack_public_path__ + "media/components/lesson2/common/statics/clientServerAnimation-fa1b897e39233aeca4962c61b6379dda.gif";